export default "__VITE_ASSET__CL8baMjO__"